/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frontrow_Point_3Inputs */

const en_frontrow_point_3 = /** @type {(inputs: Frontrow_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices, documents and tracking for every order`)
};

/**
* | output |
* | --- |
* | "Invoices, documents and tracking for every order" |
*
* @param {Frontrow_Point_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const frontrow_point_3 = /** @type {((inputs?: Frontrow_Point_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frontrow_Point_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_frontrow_point_3(inputs)
});